import React, { createContext, useContext, useState, useEffect } from 'react';

const CompareContext = createContext();

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
};

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState(() => {
    // Initialize from localStorage
    const saved = localStorage.getItem('artistCompare');
    return saved ? JSON.parse(saved) : [];
  });

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem('artistCompare', JSON.stringify(compareList));
  }, [compareList]);

  const addToCompare = (artist) => {
    if (compareList.length >= 3) {
      return { success: false, message: 'Maximum 3 artists can be compared' };
    }
    if (compareList.find(a => a.artist_id === artist.artist_id)) {
      return { success: false, message: 'Artist already in comparison' };
    }
    setCompareList([...compareList, artist]);
    return { success: true, message: 'Added to comparison' };
  };

  const removeFromCompare = (artistId) => {
    setCompareList(compareList.filter(a => a.artist_id !== artistId));
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  const isInCompare = (artistId) => {
    return compareList.some(a => a.artist_id === artistId);
  };

  return (
    <CompareContext.Provider value={{
      compareList,
      addToCompare,
      removeFromCompare,
      clearCompare,
      isInCompare,
      compareCount: compareList.length
    }}>
      {children}
    </CompareContext.Provider>
  );
};
